
const enum MarketStatus {
    'Unopened',
    'Opened',
    'Absent',
    'Closed',
    'Paused',
    'Canceled'

};
import { Marketdate } from '../marketdate';
import { User } from '../../shared';
export class MarketdateStatus {
    constructor(
        public id?: number,
        public marketdayNumber?: string,
        public status?: MarketStatus,
        public updated?: any,
        public created?: any,
        public marketdate?: Marketdate,
        public updatedBy?: User,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-status/marketdate-status.model.ts